import { Link, useLocation } from 'react-router-dom';
import { User, Menu, X } from 'lucide-react';
import LoginPopup from '../pages/SignIn';
import SignupPopup from '../pages/SignUp';
import { useState } from 'react';
import logo from "../assets/22222.png";

const Navbar = () => {
  const location = useLocation();
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const userName = localStorage.getItem('userName') || localStorage.getItem('userEmail');

  const handleSwitchToSignup = () => {
    setShowLoginPopup(false);
    setTimeout(() => setShowSignupPopup(true), 200);
  };

  const handleSwitchToLogin = () => {
    setShowSignupPopup(false);
    setTimeout(() => setShowLoginPopup(true), 200);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
    closeMobileMenu();
  };

  return (
    <>
      <nav className="bg-cyan-500 text-white shadow-lg fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 cursor-pointer" onClick={closeMobileMenu}>
              <img src={logo} alt="Aadvika Cabs" className="h-16 w-16 object-contain" />
            </Link>
            
            {/* Desktop Navigation Links */}
            <div className="hidden md:flex space-x-7 text-sm font-medium">
              <Link 
                to="/"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/' ? 'border-b-2 border-white' : ''}`}
              >
                Home
              </Link>
              <Link 
                to="/booking"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/booking' ? 'border-b-2 border-white' : ''}`}
              >
                Tour Packages
              </Link>
              <Link
                to="/vehicle"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/vehicle' ? 'border-b-2 border-white' : ''}`}
              >
                Vehicle Fleet
              </Link>
              <Link 
                to="/services"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/services' ? 'border-b-2 border-white' : ''}`}
              >
                Our Services
              </Link>
              <Link 
                to="/faq"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/faq' ? 'border-b-2 border-white' : ''}`}
              >
                FAQ
              </Link>
              <Link 
                to="/blogs"
                className={`hover:text-blue-200 transition py-1 ${location.pathname.startsWith('/blogs') || location.pathname.startsWith('/blog') ? 'border-b-2 border-white font-bold' : ''}`}
              >
                Blogs
              </Link>
              <Link 
                to="/contactus"
                className={`hover:text-blue-200 transition py-1 ${location.pathname === '/contactus' ? 'border-b-2 border-white' : ''}`}
              >
                Contact-Us
              </Link>
            </div>

            {/* Desktop Auth Buttons */}
            <div className="hidden md:flex items-center">
              {isLoggedIn ? (
                <div className="flex items-center space-x-3">
                  <div className="flex items-center">
                    <div className="bg-cyan-100 p-1.5 rounded-full">
                      <User className="h-4 w-4 text-cyan-600" />
                    </div>
                    <span className="ml-2 text-sm text-white font-medium">{userName}</span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="bg-white/20 text-white hover:bg-white/30 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => setShowLoginPopup(true)}
                    className="text-white hover:text-cyan-100 text-sm font-medium"
                  >
                    Sign In
                  </button>
                  <button
                    onClick={() => setShowSignupPopup(true)}
                    className="bg-white text-cyan-700 hover:bg-cyan-50 px-4 py-1.5 rounded-lg text-sm font-bold transition-all shadow-sm"
                  >
                    Sign Up
                  </button>
                </div>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden p-2 rounded-md text-white hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-label="Toggle Navigation Menu"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
          <div className="px-3 pt-2 pb-4 space-y-1 bg-cyan-600 border-t border-cyan-400">
            <Link
              to="/"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Home
            </Link>
            <Link
              to="/booking"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/booking' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Tour Packages
            </Link>
            <Link
              to="/vehicle"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/vehicle' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Vehicle Fleet
            </Link>
            <Link
              to="/services"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/services' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Our Services
            </Link>
            <Link
              to="/faq"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/faq' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              FAQ
            </Link>
            <Link
              to="/blogs"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname.startsWith('/blogs') || location.pathname.startsWith('/blog') ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Blogs
            </Link>
            <Link
              to="/contactus"
              className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-cyan-700 ${location.pathname === '/contactus' ? 'bg-cyan-700 font-bold' : ''}`}
              onClick={closeMobileMenu}
            >
              Contact-Us
            </Link>

            {/* Mobile Auth Section */}
            <div className="pt-4 pb-2 border-t border-cyan-500">
              {isLoggedIn ? (
                <div className="flex items-center justify-between px-3 py-2">
                  <div className="flex items-center">
                    <div className="bg-cyan-100 p-1.5 rounded-full">
                      <User className="h-4 w-4 text-cyan-700" />
                    </div>
                    <div className="ml-3 text-sm font-medium text-white">{userName}</div>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="bg-white text-cyan-700 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-100 transition-all"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <div className="flex flex-col space-y-2 px-3 pt-2">
                  <button
                    onClick={() => {
                      setShowLoginPopup(true);
                      closeMobileMenu();
                    }}
                    className="w-full bg-cyan-700 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-cyan-800 transition-all text-center"
                  >
                    Sign In
                  </button>
                  <button
                    onClick={() => {
                      setShowSignupPopup(true);
                      closeMobileMenu();
                    }}
                    className="w-full bg-white text-cyan-700 px-4 py-2.5 rounded-lg text-sm font-bold hover:bg-cyan-50 transition-all text-center shadow"
                  >
                    Sign Up
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Popups */}
      <LoginPopup 
        isOpen={showLoginPopup} 
        onClose={() => setShowLoginPopup(false)}
        onSwitchToSignup={handleSwitchToSignup}
      />
      
      <SignupPopup 
        isOpen={showSignupPopup} 
        onClose={() => setShowSignupPopup(false)}
        onSwitchToLogin={handleSwitchToLogin}
      />
    </>
  );
};

export default Navbar;
